import {Space} from 'antd';
import styled from 'styled-components';
import {bordersStyles} from '../../../../utils/styles';

const StyledVendorsTableContainer = styled.div`
  ${bordersStyles.light};

  & > div {
    border-radius: 4px;
  }

  .ant-empty-description {
    h3 {
      font-size: 20px;
    }
  }
`;

const StyledVendorsTableSpace = styled(Space)`
  background-color: ${props => props.theme.colors.neutral_1};
  min-height: calc(100vh - 24px * 2 - 66px);
  padding: 24px;
  position: relative;
  width: 100%;
`;


const StyledVendorsTableAmountSpace = styled(Space)`
  svg {
    height: 24px;
    width: 24px;
  }

  .icon {
    display: inline-flex;

    &.negative {
      svg {
        path {
          fill: ${props => props.theme.colors.functional_danger};
          stroke: ${props => props.theme.colors.functional_danger};
        }
      }
    }

    &.positive {
      svg {
        path {
          fill: ${props => props.theme.colors.functional_success};
          stroke: ${props => props.theme.colors.functional_success};
        }
      }
    }
  }

  .ant-space-item {
    display: flex;
  }
`;

export {
  StyledVendorsTableContainer,
  StyledVendorsTableSpace,
  StyledVendorsTableAmountSpace,
}
